import { render } from "./YellowRegistrationStepThree.vue?vue&type=template&id=283e0752"
import script from "./YellowRegistrationStepThree.vue?vue&type=script&lang=js"
export * from "./YellowRegistrationStepThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__